import { useState, useRef, useEffect } from "react";
import MainLayout from "@/components/feature/MainLayout";

const reportTypes = [
  { value: "revenue", label: "营收分析报告", icon: "ri-money-cny-circle-line" },
  { value: "safety", label: "安全检查报告", icon: "ri-shield-check-line" },
  { value: "user", label: "用户画像报告", icon: "ri-user-3-line" },
  { value: "device", label: "设备运行报告", icon: "ri-cpu-line" },
  { value: "arrears", label: "欠费分析报告", icon: "ri-error-warning-line" },
  { value: "gas", label: "用气量分析报告", icon: "ri-gas-station-line" },
];

const timeRanges = ["近一周", "近一个月", "近一季度", "近半年", "近一年", "自定义"];

const aiReports: Record<string, string> = {
  revenue: `【AI营收分析报告 - 2026年4月】

一、营收总体概况
本月累计营收 ¥856,420.50，同比增长 12.3%，环比增长 5.8%。日均营收 ¥28,547，较上月提升 ¥1,580。

二、营收结构分析
▶ 居民用户：¥586,420（占比68.5%），同比+8.2%
▶ 工商业用户：¥198,650（占比23.2%），同比+18.6%
▶ 工业用户：¥71,350（占比8.3%），同比+15.1%

工商业用户增速最快，主要受餐饮业复苏带动，建议重点维护工商业大客户关系。

三、营收趋势分析
本月营收呈现"前低后高"走势，月初受春节假期影响偏低，月中后随工商业复工快速回升。第4周营收 ¥259,620，创近6个月单周新高。

四、欠费情况
当前欠费总额 ¥45,680.20，欠费率 5.3%，较上月下降 0.8%。欠费用户主要集中在居民用户群体（占欠费总额72%）。

五、AI预测与建议
预测下月营收区间：¥880,000 - ¥920,000（置信度85%）
1. 建议加强对欠费用户的短信催缴，预计可回收 ¥32,000+
2. 工商业用户增长势头良好，建议推出大用量优惠套餐
3. 居民用户夏季用气量将下降，建议提前做好营收预期管理`,

  safety: `【AI安全检查报告 - 2026年4月】

一、安检总体情况
本月计划安检 156 户，已完成 147 户，完成率 94.2%，逾期未检 9 户。

二、AI风险识别
▶ 高风险用户：3户（燃气泄漏隐患）
▶ 中风险用户：12户（设备老化/管道问题）
▶ 低风险用户：132户（正常）

三、问题类型分布
- 软管老化：38例（占比25.9%）
- 阀门密封不良：22例（占比15.0%）
- 燃气灶具问题：18例（占比12.2%）
- 通风不良：15例（占比10.2%）

四、AI建议
1. 对3户高风险用户立即安排复检
2. 软管老化问题突出，建议开展专项更换活动
3. 逾期9户建议本周内完成安检`,

  user: `【AI用户画像报告 - 2026年4月】

一、用户总体概况
系统注册用户 128,456 户，活跃用户 121,832 户（活跃率94.8%）。本月新增用户 1,256 户，流失用户 89 户，净增 1,167 户。

二、用户结构分析
▶ 居民用户：115,145 户（89.6%）
▶ 工商业用户：11,201 户（8.7%）
▶ 工业用户：2,110 户（1.6%）

三、用户行为特征
- 月均用气量：居民 28.5m³，工商业 285m³，工业 2,850m³
- 缴费方式：银行代扣 58%，微信/支付宝 32%，现金 10%
- 欠费用户：6,823 户（5.3%），主要集中在老旧小区

四、AI洞察
1. 老龄用户（60岁以上）占比 23%，安全风险较高，建议加强上门服务
2. 新装用户前3个月用气量较低，建议推送用气指导
3. 高用量工商业用户 TOP20 贡献营收 18%，需重点维护`,

  device: `【AI设备运行报告 - 2026年4月】

一、设备总体状况
在线设备 142,568 台，在线率 97.2%。本月新增设备 856 台，报废设备 23 台。

二、设备健康分析
▶ 健康状态：138,562 台（97.2%）
▶ 预警状态：2,856 台（2.0%）
▶ 故障状态：23 台（0.02%）
▶ 维护中：1,127 台（0.79%）

三、故障类型分布
- 通信故障：45%（信号弱/断网）
- 电池耗尽：28%（需更换电池）
- 阀门故障：15%（机械故障）
- 传感器异常：12%（需校准）

四、AI预测
预测未来30天内可能故障设备：127台
建议提前安排预防性维护，可降低故障率 68%`,

  arrears: `【AI欠费分析报告 - 2026年4月】

一、欠费总体情况
当前欠费总额 ¥45,680.20，欠费用户 6,823 户，欠费率 5.3%。

二、欠费分布
▶ 欠费1个月内：4,521 户（¥28,450）
▶ 欠费1-3个月：1,856 户（¥12,680）
▶ 欠费3-6个月：389 户（¥3,850）
▶ 欠费6个月以上：57 户（¥700）

三、欠费原因分析（AI识别）
- 忘记缴费：62%（可通过短信提醒解决）
- 经济困难：18%（需人工跟进）
- 对账单有异议：12%（需客服处理）
- 其他：8%

四、AI催缴建议
1. 对欠费1个月内用户发送短信提醒，预计回收率 78%
2. 对欠费3个月以上用户安排电话催缴
3. 对欠费6个月以上用户启动法律程序`,

  gas: `【AI用气量分析报告 - 2026年4月】

一、用气量总体概况
本月总用气量 285.6 万m³，同比增长 8.7%，环比下降 3.2%（季节性因素）。

二、用气量结构
▶ 居民用气：198.5 万m³（69.5%）
▶ 工商业用气：68.2 万m³（23.9%）
▶ 工业用气：18.9 万m³（6.6%）

三、用气趋势
早高峰（07:00-09:00）用气量占全天 28%，晚高峰（18:00-20:00）占全天 32%。冬季用气量是夏季的 2.3 倍。

四、AI预测
预测下月用气量：295 万m³（±3%）
预测夏季最低月用气量：185 万m³（7月）
建议提前做好管网压力调配方案`,
};

const summaries: Record<string, string> = {
  revenue: "本月营收 ¥856,420，同比+12.3%，工商业增速最快(+18.6%)。欠费率5.3%，较上月降0.8%。AI预测下月营收 ¥880,000-¥920,000，建议加强短信催缴。",
  safety: "本月安检完成率94.2%，逾期9户。AI识别高风险3户、中风险12户。软管老化问题最突出(25.9%)，建议立即安排3户高风险用户复检。",
  user: "用户总量128,456户，活跃率94.8%，净增1,167户。老龄用户占23%安全风险较高，TOP20工商业用户贡献营收18%，需重点维护。",
  device: "设备在线率97.2%，故障23台。AI预测未来30天可能故障127台，提前维护可降低故障率68%。通信故障占比最高(45%)。",
  arrears: "欠费总额¥45,680，欠费率5.3%。62%因忘记缴费，短信提醒回收率可达78%。建议对6个月以上欠费57户启动法律程序。",
  gas: "本月用气285.6万m³，同比+8.7%。晚高峰占全天32%，冬季是夏季2.3倍。AI预测下月295万m³，建议提前做好管网压力调配。",
};

export default function AIReportPage() {
  const [reportType, setReportType] = useState("revenue");
  const [timeRange, setTimeRange] = useState("近一个月");
  const [customPrompt, setCustomPrompt] = useState("");
  const [generating, setGenerating] = useState(false);
  const [report, setReport] = useState("");
  const [showExportModal, setShowExportModal] = useState(false);
  const [exportFormat, setExportFormat] = useState<"pdf" | "excel" | "word">("pdf");
  const [exporting, setExporting] = useState(false);
  const [exportDone, setExportDone] = useState(false);
  const [showSummary, setShowSummary] = useState(false);
  const [summaryText, setSummaryText] = useState("");
  const [generatingSummary, setGeneratingSummary] = useState(false);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const summaryTimerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const generateReport = (custom = false) => {
    setGenerating(true);
    setReport("");
    setShowSummary(false);
    setSummaryText("");
    const text = custom && customPrompt
      ? `【AI自定义分析报告】\n\n根据您的要求"${customPrompt}"，AI正在分析相关数据...\n\n` + (aiReports[reportType] || aiReports.revenue)
      : (aiReports[reportType] || aiReports.revenue);

    let i = 0;
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      if (i < text.length) {
        setReport(text.slice(0, i + 1));
        i += 4;
      } else {
        setReport(text);
        if (timerRef.current) clearInterval(timerRef.current);
        setGenerating(false);
        // Auto generate summary after report
        setTimeout(() => generateSummary(), 500);
      }
    }, 15);
  };

  const generateSummary = () => {
    setShowSummary(true);
    setGeneratingSummary(true);
    setSummaryText("");
    const text = summaries[reportType] || summaries.revenue;
    let i = 0;
    if (summaryTimerRef.current) clearInterval(summaryTimerRef.current);
    summaryTimerRef.current = setInterval(() => {
      if (i < text.length) {
        setSummaryText(text.slice(0, i + 1));
        i += 3;
      } else {
        setSummaryText(text);
        if (summaryTimerRef.current) clearInterval(summaryTimerRef.current);
        setGeneratingSummary(false);
      }
    }, 20);
  };

  const handleExport = () => {
    setExporting(true);
    setTimeout(() => {
      setExporting(false);
      setExportDone(true);
      setTimeout(() => setExportDone(false), 3000);
      setShowExportModal(false);
    }, 2000);
  };

  useEffect(() => () => {
    if (timerRef.current) clearInterval(timerRef.current);
    if (summaryTimerRef.current) clearInterval(summaryTimerRef.current);
  }, []);

  return (
    <MainLayout>
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-lg font-bold text-gray-900">AI智能报告</h2>
            <p className="text-xs text-gray-400 mt-0.5">利用AI技术自动分析数据，生成专业分析报告，支持PDF/Excel导出</p>
          </div>
          {exportDone && (
            <div className="flex items-center gap-2 bg-green-50 border border-green-200 text-green-700 px-4 py-2 rounded-xl text-sm">
              <i className="ri-check-double-line"></i>
              导出成功！文件已下载
            </div>
          )}
        </div>

        <div className="grid grid-cols-3 gap-4">
          {/* Left: Config */}
          <div className="space-y-4">
            <div className="bg-white rounded-xl border border-gray-100 p-5">
              <h3 className="text-sm font-semibold text-gray-800 mb-3">报告类型</h3>
              <div className="space-y-2">
                {reportTypes.map(rt => (
                  <button
                    key={rt.value}
                    onClick={() => setReportType(rt.value)}
                    className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm transition-colors cursor-pointer ${
                      reportType === rt.value ? "bg-orange-50 text-[#E8531A] border border-[#E8531A]/20" : "text-gray-600 hover:bg-gray-50"
                    }`}
                  >
                    <i className={`${rt.icon} text-base`}></i>
                    {rt.label}
                  </button>
                ))}
              </div>
            </div>

            <div className="bg-white rounded-xl border border-gray-100 p-5">
              <h3 className="text-sm font-semibold text-gray-800 mb-3">时间范围</h3>
              <div className="grid grid-cols-2 gap-2">
                {timeRanges.map(tr => (
                  <button
                    key={tr}
                    onClick={() => setTimeRange(tr)}
                    className={`py-2 rounded-lg text-xs font-medium border transition-colors cursor-pointer whitespace-nowrap ${
                      timeRange === tr ? "border-[#E8531A] bg-orange-50 text-[#E8531A]" : "border-gray-200 text-gray-500 hover:border-gray-300"
                    }`}
                  >
                    {tr}
                  </button>
                ))}
              </div>
            </div>

            <div className="bg-white rounded-xl border border-gray-100 p-5">
              <h3 className="text-sm font-semibold text-gray-800 mb-3">自定义要求</h3>
              <textarea
                value={customPrompt}
                onChange={e => setCustomPrompt(e.target.value)}
                placeholder="输入自定义分析要求，如：重点分析工商业用户营收增长原因..."
                rows={4}
                maxLength={500}
                className="w-full px-3 py-2 text-xs border border-gray-200 rounded-lg focus:outline-none focus:border-[#E8531A]/50 resize-none"
              />
              <p className="text-[10px] text-gray-300 text-right">{customPrompt.length}/500</p>
            </div>

            <div className="flex flex-col gap-2">
              <button
                onClick={() => generateReport(false)}
                disabled={generating}
                className="w-full flex items-center justify-center gap-2 bg-[#E8531A] text-white py-3 rounded-xl text-sm font-medium cursor-pointer hover:bg-[#d44a15] disabled:opacity-60 whitespace-nowrap"
              >
                {generating ? <><i className="ri-loader-4-line animate-spin"></i>AI生成中...</> : <><i className="ri-robot-2-line"></i>AI自动生成</>}
              </button>
              {customPrompt && (
                <button
                  onClick={() => generateReport(true)}
                  disabled={generating}
                  className="w-full flex items-center justify-center gap-2 border border-[#E8531A] text-[#E8531A] py-3 rounded-xl text-sm font-medium cursor-pointer hover:bg-orange-50 disabled:opacity-60 whitespace-nowrap"
                >
                  <i className="ri-magic-line"></i>自定义生成
                </button>
              )}
            </div>
          </div>

          {/* Right: Report */}
          <div className="col-span-2 flex flex-col gap-4">
            <div className="bg-white rounded-xl border border-gray-100 p-5 flex-1">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-2">
                  <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-orange-50">
                    <i className="ri-robot-2-line text-[#E8531A] text-sm"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-gray-800">
                    {reportTypes.find(r => r.value === reportType)?.label} · {timeRange}
                  </h3>
                  {generating && (
                    <span className="flex items-center gap-1 text-xs text-[#E8531A]">
                      <i className="ri-loader-4-line animate-spin"></i>AI生成中
                    </span>
                  )}
                </div>
                {report && (
                  <div className="flex gap-2">
                    <button
                      onClick={() => setShowExportModal(true)}
                      className="flex items-center gap-1.5 bg-[#E8531A] text-white px-3 py-1.5 rounded-lg text-xs font-medium cursor-pointer hover:bg-[#d44a15] whitespace-nowrap"
                    >
                      <i className="ri-download-2-line"></i>导出报告
                    </button>
                    <button className="flex items-center gap-1.5 border border-gray-200 text-gray-600 px-3 py-1.5 rounded-lg text-xs cursor-pointer hover:bg-gray-50 whitespace-nowrap">
                      <i className="ri-mail-send-line text-teal-500"></i>发送邮件
                    </button>
                    <button className="flex items-center gap-1.5 border border-gray-200 text-gray-600 px-3 py-1.5 rounded-lg text-xs cursor-pointer hover:bg-gray-50 whitespace-nowrap">
                      <i className="ri-printer-line text-gray-500"></i>打印
                    </button>
                  </div>
                )}
              </div>

              {report ? (
                <div className="bg-gray-50 rounded-xl p-5 text-xs text-gray-700 leading-relaxed whitespace-pre-line font-mono overflow-y-auto" style={{ minHeight: "420px", maxHeight: "420px" }}>
                  {report}
                  {generating && <span className="animate-pulse text-[#E8531A]">|</span>}
                </div>
              ) : (
                <div className="flex flex-col items-center justify-center" style={{ minHeight: "420px" }}>
                  <div className="w-20 h-20 flex items-center justify-center rounded-full bg-orange-50 mb-4">
                    <i className="ri-robot-2-line text-[#E8531A] text-4xl"></i>
                  </div>
                  <p className="text-sm text-gray-400 mb-2">选择报告类型和时间范围</p>
                  <p className="text-xs text-gray-300">点击「AI自动生成」按钮，AI将自动分析数据并生成专业报告</p>
                  <div className="mt-6 grid grid-cols-3 gap-3">
                    {["自动识别数据异常", "多维度深度分析", "支持PDF/Excel导出"].map((f, i) => (
                      <div key={i} className="flex items-center gap-2 px-3 py-2 bg-gray-50 rounded-lg">
                        <i className="ri-check-line text-[#E8531A] text-sm"></i>
                        <span className="text-xs text-gray-500">{f}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* AI Summary Panel */}
            {showSummary && (
              <div className="bg-gradient-to-r from-orange-50 to-amber-50 rounded-xl border border-[#E8531A]/20 p-4">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-6 h-6 flex items-center justify-center rounded-lg bg-[#E8531A]/10">
                    <i className="ri-sparkling-2-line text-[#E8531A] text-sm"></i>
                  </div>
                  <span className="text-sm font-semibold text-[#E8531A]">AI智能摘要</span>
                  {generatingSummary && (
                    <span className="flex items-center gap-1 text-xs text-[#E8531A]/60">
                      <i className="ri-loader-4-line animate-spin text-xs"></i>生成中
                    </span>
                  )}
                  <div className="ml-auto flex gap-2">
                    <button
                      onClick={() => setShowExportModal(true)}
                      className="text-xs text-[#E8531A] border border-[#E8531A]/30 px-2 py-1 rounded-lg cursor-pointer hover:bg-[#E8531A]/5 whitespace-nowrap"
                    >
                      <i className="ri-file-pdf-line mr-1"></i>导出PDF
                    </button>
                    <button
                      onClick={() => setShowExportModal(true)}
                      className="text-xs text-green-600 border border-green-300 px-2 py-1 rounded-lg cursor-pointer hover:bg-green-50 whitespace-nowrap"
                    >
                      <i className="ri-file-excel-2-line mr-1"></i>导出Excel
                    </button>
                  </div>
                </div>
                <p className="text-sm text-gray-700 leading-relaxed">
                  {summaryText}
                  {generatingSummary && <span className="inline-block w-0.5 h-3.5 bg-[#E8531A] animate-pulse ml-0.5 align-middle"></span>}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Export Modal */}
      {showExportModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50" onClick={() => setShowExportModal(false)}>
          <div className="bg-white rounded-2xl p-6 w-[480px]" onClick={e => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-5">
              <h3 className="text-base font-bold text-gray-900">导出报告</h3>
              <button onClick={() => setShowExportModal(false)} className="w-7 h-7 flex items-center justify-center rounded-full hover:bg-gray-100 cursor-pointer">
                <i className="ri-close-line text-gray-500"></i>
              </button>
            </div>

            {exporting ? (
              <div className="text-center py-8">
                <div className="w-16 h-16 rounded-full bg-orange-50 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-loader-4-line animate-spin text-[#E8531A] text-3xl"></i>
                </div>
                <div className="text-sm font-medium text-gray-700 mb-1">正在生成{exportFormat.toUpperCase()}文件...</div>
                <div className="text-xs text-gray-400">AI正在排版和格式化报告内容</div>
                <div className="mt-4 w-full bg-gray-100 rounded-full h-2">
                  <div className="bg-[#E8531A] h-2 rounded-full animate-pulse" style={{ width: "70%" }}></div>
                </div>
              </div>
            ) : (
              <>
                {/* Format selection */}
                <div className="mb-5">
                  <label className="text-xs text-gray-500 mb-3 block">选择导出格式</label>
                  <div className="grid grid-cols-3 gap-3">
                    {[
                      { key: "pdf", label: "PDF文档", icon: "ri-file-pdf-2-line", color: "text-red-500", desc: "适合打印和分享" },
                      { key: "excel", label: "Excel表格", icon: "ri-file-excel-2-line", color: "text-green-600", desc: "适合数据分析" },
                      { key: "word", label: "Word文档", icon: "ri-file-word-2-line", color: "text-sky-600", desc: "适合编辑修改" },
                    ].map(fmt => (
                      <button
                        key={fmt.key}
                        onClick={() => setExportFormat(fmt.key as typeof exportFormat)}
                        className={`flex flex-col items-center gap-2 p-4 rounded-xl border-2 transition-colors cursor-pointer ${exportFormat === fmt.key ? "border-[#E8531A] bg-orange-50" : "border-gray-100 hover:border-gray-200"}`}
                      >
                        <i className={`${fmt.icon} text-2xl ${fmt.color}`}></i>
                        <div className="text-center">
                          <div className={`text-xs font-semibold ${exportFormat === fmt.key ? "text-[#E8531A]" : "text-gray-700"}`}>{fmt.label}</div>
                          <div className="text-[10px] text-gray-400 mt-0.5">{fmt.desc}</div>
                        </div>
                      </button>
                    ))}
                  </div>
                </div>

                {/* Export options */}
                <div className="mb-5 space-y-3">
                  <label className="text-xs text-gray-500 block">导出内容</label>
                  <div className="space-y-2">
                    {[
                      { label: "完整报告正文", checked: true, disabled: true },
                      { label: "AI智能摘要", checked: true, disabled: false },
                      { label: "数据图表（仅PDF/Word）", checked: exportFormat !== "excel", disabled: exportFormat === "excel" },
                      { label: "附录：原始数据表", checked: false, disabled: false },
                    ].map((opt, i) => (
                      <label key={i} className={`flex items-center gap-2 cursor-pointer ${opt.disabled ? "opacity-50" : ""}`}>
                        <input type="checkbox" defaultChecked={opt.checked} disabled={opt.disabled} className="accent-[#E8531A]" />
                        <span className="text-sm text-gray-700">{opt.label}</span>
                      </label>
                    ))}
                  </div>
                </div>

                {/* File name */}
                <div className="mb-5">
                  <label className="text-xs text-gray-500 mb-1.5 block">文件名称</label>
                  <input
                    type="text"
                    defaultValue={`${reportTypes.find(r => r.value === reportType)?.label}_${timeRange}_2026-04-10`}
                    className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#E8531A]"
                  />
                </div>

                <div className="flex gap-2">
                  <button onClick={() => setShowExportModal(false)} className="flex-1 border border-gray-200 text-gray-600 py-2.5 rounded-xl text-sm cursor-pointer hover:bg-gray-50 whitespace-nowrap">取消</button>
                  <button onClick={handleExport} className="flex-1 bg-[#E8531A] text-white py-2.5 rounded-xl text-sm font-medium cursor-pointer hover:bg-[#d44a15] whitespace-nowrap">
                    <i className="ri-download-2-line mr-1"></i>确认导出
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </MainLayout>
  );
}
